import { FC } from 'react';
import BaseAlert, { AlertTypes } from '../BaseAlert';

import styles from './AlertsList.module.css';

type Props = { errors: string[] };

const AlertsList: FC<Props> = ({ errors }) => (
  <div className={styles.container}>
    {errors.map((errorItem) => (
      <BaseAlert key={errorItem} type={AlertTypes.warning}>
        {errorItem}
      </BaseAlert>
    ))}
  </div>
);

export default AlertsList;
